(function () {
  let angular = window.angular;

  Router.$inject = ['$stateProvider'];

  angular.module('app').config(Router);

  function Router($stateProvider) {
    $stateProvider
      .state('member.customer.show.project.tfa', {
        url: '/tfa',
        redirectTo: 'member.customer.show.project.tfa.home',
        template: '<ui-view></ui-view>',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Traffic Flow Analysis',
        },
        resolve: {
          hasTool: [
            'tools',
            'AppUtils',
            function (tools, utils) {
              const hasTool = tools.find((tool) => tool.module === 'xompassTrafficFlowAnalysis');
              if (!hasTool) {
                throw utils.getHTTPError(new Error('Not allowed'), {
                  redirectTo: 'member.customer.invalidTool',
                  params: { tool: 'xompassTrafficFlowAnalysis' },
                });
              }
            },
          ],
          module: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([window.assetsPath + '/js/app/tfa.module.min.js']);
            },
          ],
        },
      })
      .state('member.customer.show.project.tfa.home', {
        url: '/',
        component: 'tfaHome',
        authenticated: true,
        resolve: {
          tfa: [
            'EntityService',
            '$transition$',
            function (EntityService, $transition$) {
              const options = Object.assign({ order: 'name ASC' }, $transition$.params());
              return EntityService.find('TrafficFlowAnalysis', options);
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"general.gallery" | translate}}',
        },
      })
      .state('member.customer.show.project.tfa.dashboard', {
        url: '/:tfaId',
        redirectTo: 'member.customer.show.project.tfa.dashboard.viewer',
        component: 'tfaDashboard',
        authenticated: true,
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
              ]);
            },
          ],
          virtualGroups: [
            '$rootScope',
            'Customer',
            ($root, Customer) => {
              return Customer.prototype$__get__projects__virtualGroups({
                id: $root.customerId,
                nk: $root.projectId,
              }).$promise;
            },
          ],
          virtualExpressions: [
            '$rootScope',
            'VirtualExpressionService',
            function ($root, VirtualExpressionService) {
              return VirtualExpressionService.find($root.customerId, $root.projectId, {
                fields: ['id', 'name', 'description', 'expression', 'virtualGroupId'],
              });
            },
          ],
          tfa: [
            'EntityService',
            '$transition$',
            'AppUtils',
            function (EntityService, $transition$, utils) {
              return loadTFA(EntityService, $transition$.params(), utils);
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{$resolve.tfa.name}}',
        },
      })
      .state('member.customer.show.project.tfa.dashboard.viewer', {
        url: '/viewer',
        component: 'tfaViewer',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Viewer',
        },
      })
      .state('member.customer.show.project.tfa.dashboard.editor', {
        url: '/editor',
        component: 'tfaEditor',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Editor',
        },
      })
      .state('member.customer.show.project.tfa.dashboard.managers', {
        url: '/managers',
        component: 'tfaManagers',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Managers',
        },
      });

    function loadTFA(EntityService, params, utils) {
      const options = angular.copy(params);
      options.entityId = options.tfaId;
      options.filter = { include: { relation: 'vertices' } };

      return EntityService.findById('TrafficFlowAnalysis', options).catch((err) => {
        console.log(err);
        throw utils.getHTTPError(err, {
          redirectTo: 'member.customer.show.project.tfa.home',
        });
      });
    }
  }
})();
